var _circle, _path;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgCardSelectedIcon = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 25,
    viewBox: "10 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 0C7.1632 0 0 7.1632 0 16C0 24.8368 7.1632 32 16 32C24.8368 32 32 24.8368 32 16C32 7.1632 24.8368 0 16 0ZM13.5071 23.9553C13.1166 24.3458 12.4834 24.3458 12.0929 23.9553L5.97591 17.8383C5.58538 17.4478 5.58538 16.8146 5.97591 16.4241L6.82409 15.5759C7.21462 15.1854 7.84778 15.1854 8.23831 15.5759L12.0929 19.4305C12.4834 19.821 13.1166 19.821 13.5071 19.4305L23.7617 9.17591C24.1522 8.78538 24.7854 8.78538 25.1759 9.17591L26.0241 10.0241C26.4146 10.4146 26.4146 11.0478 26.0241 11.4383L13.5071 23.9553Z",
    fill: "#3C3ADA"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgCardSelectedIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/Card_Selected_icon.fb932083.svg";
export { ForwardRef as ReactComponent };